import i18next from 'i18next'
import { isEmail } from 'lodash-checkit'
import { FormErrors } from 'redux-form'
import { ILoginFormValues } from './LoginForm'

export default (values: ILoginFormValues) => {
	const errors: FormErrors<ILoginFormValues> = {}

	if (!values.email) {
		errors.email = i18next.t('loc:general|This field is required')
	} else if (values.email.length > 255) {
		errors.email = i18next.t('loc:general|Maximum number of characters is {{max}}', { max: 255 })
	} else if (!isEmail(values.email)) {
		errors.email = i18next.t('loc:general|Email format is incorrect')
	}

	if (!values.password) {
		errors.password = i18next.t('loc:general|This field is required')
	} else if (values.password.length > 255) {
		errors.password = i18next.t('loc:general|Maximum number of characters is {{max}}', { max: 255 })
	}

	return errors
}
